const fontFamily = {
  primary: 'Kanit',
  regular: 'Kanit',
  medium: 'KanitMedium',
  bold: 'KanitSemiBold',
}

export default fontFamily
